export var IS_PRODUCTION = process.env.NODE_ENV === 'production';
//# sourceMappingURL=environment.js.map